import { createClient } from "@sanity/client";

export const sanityClient = createClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
  dataset: process.env.REACT_APP_SANITY_DATASET || "production",
  apiVersion: "2026-05-18",
  useCdn: true,
});
